export default "__VITE_ASSET__B5owL8UJ__"